// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1OK9M","search":"Settings_search__3BIWU","filter":"Settings_filter__PBHCe"};